import { Grid, GridItem, Button, Icon } from '@chakra-ui/react'
import { Link } from 'react-router-dom'
import { MdOutlineCameraAlt } from 'react-icons/md'
import { BsClipboardCheck, BsBoxSeam } from 'react-icons/bs'
import { HiOutlineClipboardCopy } from 'react-icons/hi'

const iconComponents = {
  MdOutlineCameraAlt,
  BsClipboardCheck,
  BsBoxSeam,
  HiOutlineClipboardCopy,
}

export function MenuButtons({ options }) {
  const getIconComponent = (iconName) => {
    return iconComponents[iconName] || MdOutlineCameraAlt
  }

  return (
    <Grid templateColumns={{ base: 'repeat(2, 1fr)', md: 'repeat(2, 1fr)' }} gap={6}>
      {options.map((option, index) => (
        <GridItem key={index}>
          <Link to={!option.to ? '#' : option.to}>
            <Button
              w={'full'}
              h={180}
              shadow={'lg'}
              fontSize={'lg'}
              bgColor={option.bg}
              textColor={'white'}
              rounded={'xl'}
              _focus={{ border: 'none' }}
              _active={{}}
              _hover={{
                bg: option.bg,
                transform: 'none',
              }}
              disabled={!option.to}
              pointerEvents={!option.to ? 'none' : 'auto'}
              flexDirection={'column'}
              whiteSpace={'break-spaces'}
            >
              <Icon as={getIconComponent(option.icon)} boxSize={14} color="white" my={4} />
              {option.label}
            </Button>
          </Link>
        </GridItem>
      ))}
    </Grid>
  )
}
